import {reverseGeocoding} from '../api/google-integration'

export type LatLng = {lat: number, lng: number}

export class Geocoding{
    private qualifier: string
    
    private addresses: {[key:string]: string} = null

    constructor(qualifier?: string){   
        
        this.addresses = {}     
        this.qualifier = qualifier
    }

    public setQualifier = (qualifier) => {
        this.qualifier = qualifier
    }

    public buildUrlSearchParams = (latLngsStr: string[] = []): URLSearchParams => {
        const params = new URLSearchParams();
        latLngsStr.forEach(latLng => {                      
            if(!this.addresses[latLng]) params.append("latLngs", latLng);
        })

        return params
    }

    public fillAddresses = async (latLngs: LatLng[] = []) => {   
        if(!this.qualifier) return 
        
        const formattedLatLng = latLngs
            .filter((value) => {
                const exist = this.containKey(value)                
                return !exist
            }) 
            .map(latLng => {
                const formatedValue = format(latLng)                
                return formatedValue
            })
        
        if(formattedLatLng.length === 0) return
        
        
        const params = this.buildUrlSearchParams(formattedLatLng)
        const res = await reverseGeocoding(this.qualifier, params)

        res?.forEach((result, index) => {            
            const {geocodingResult: {formattedAddress}} = result || {geocodingResult: {}}
            const key = formattedLatLng[index]

            this.addresses[key] = formattedAddress
        })
    }

    public getAddress = (latLng: LatLng) => {
        const key = format(latLng)           
        return this.addresses[key]
    }

    public getAddresses = () => this.addresses

    public containKey = (latLng: LatLng) => {
        const key = format(latLng)           
        return Object.keys(this.addresses).find(ele => ele === key) ? true : false      
    }

    
}

let geocodingInstance: Geocoding | null = null;

export const format = (latLng: LatLng) => `${latLng.lat},${latLng.lng}`;

export function getGeocodingInstance(qualifier: string): Geocoding {
    if (!geocodingInstance) {
        geocodingInstance = new Geocoding(qualifier);
    }
    return geocodingInstance;
}